import { create } from "zustand";
import { persist } from "zustand/middleware";

// Mirror of the MENU structure — used to resolve parent permissions
// from child keys without importing the full MENU constant
const PERMISSION_CHILDREN = {
  users_data: ["users", "user_types", "companies_info"],
  ticketing:  ["events", "orders", "clients", "sales_tags"],
  marketing:  ["landing_pages", "links", "pixels"],
  financial:  ["financial", "payees", "company-expenses"],
};

// Keys that organizers always get, regardless of their permissions object
const ORGANIZER_ALLOWED = ["events", "ticketing"];

export const useAuthStore = create(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      permissions: {},
      isAuthenticated: false,

      login: ({ access, refresh, user }) => {
        set({
          accessToken: access,
          refreshToken: refresh,
          user,
          isAuthenticated: true,
        });
      },

      setPermissions: (permissions) => {
        set({ permissions });
      },

      logout: () => {
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          permissions: {},
          isAuthenticated: false,
        });
      },

      hasPermission: (key) => {
        const { permissions, user } = get();

        // Organizers always see Events + its Ticketing Platform parent
        // regardless of what their permissions object says
        if (user?.user_category === "organizer" && ORGANIZER_ALLOWED.includes(key)) {
          return true;
        }

        // Direct match — e.g. key = "events" and permissions.events = true
        if (permissions[key]) return true;

        // Parent match — e.g. key = "ticketing", check if any child is granted
        // This makes parent menu items visible when only a sub-permission is set
        const children = PERMISSION_CHILDREN[key];
        if (children) {
          return children.some((childKey) => !!permissions[childKey]);
        }

        return false;
      },

      // Returns true when the user should have read-only access
      // Driven by user_category from the login response
      isViewOnly: () => {
        return get().user?.user_category === "organizer";
      },
    }),
    {
      name: "auth-storage",
    },
  ),
);